export function IconElbow() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M4.5 2.5v3a2 2 0 0 0 2 2h3" stroke="#BEC5C9" strokeLinecap="round"/>
        </svg>
    );
}
